import { render, staticRenderFns } from "./MeasurementTable.vue?vue&type=template&id=37b31be6&"
import script from "./MeasurementTable.vue?vue&type=script&lang=js&"
export * from "./MeasurementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Applications/MAMP/htdocs/nc21docker/apps/health/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b31be6')) {
      api.createRecord('37b31be6', component.options)
    } else {
      api.reload('37b31be6', component.options)
    }
    module.hot.accept("./MeasurementTable.vue?vue&type=template&id=37b31be6&", function () {
      api.rerender('37b31be6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/measurement/MeasurementTable.vue"
export default component.exports